import { render, staticRenderFns } from "./IcMenu.vue?vue&type=template&id=547b8614&scoped=true"
import script from "./IcMenu.vue?vue&type=script&lang=js"
export * from "./IcMenu.vue?vue&type=script&lang=js"
import style0 from "./IcMenu.vue?vue&type=style&index=0&id=547b8614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547b8614",
  null
  
)

export default component.exports